import { selector } from 'recoil'

import { DossierIdState } from './State'
export const DossierIdSelector = selector({
    key:'dossierIdSELECTOR',
    get: ({get}) => {
        return get(DossierIdState)
    }
})